module.exports = __webpack_public_path__ + "static/service02-b5a4d5cb0d616f2649007be6c4ed2786.png";